<template>
	<div style="margin: 10px;" v-loading="loading">
		<el-row>
			<el-col :spa="24">
				<el-card class="box-card">
					<h4 class="title">专题信息</h4>
					<el-form ref="form" :model="form" label-width="120px" :rules="rules">
						<el-form-item label="栏目名称" prop="cid">
							<el-input v-model="form.cid" style="width: 30%;" placeholder="添加栏目名称" readonly></el-input>
						</el-form-item>
						<el-form-item label="专题类型" prop="typeId" >
                            <!-- <span style="color: #000;font-size: 16px;" v-show="Setypes"></span> -->
                            <el-select placeholder="请选择专题类型" size="mini" v-model="form.typeId" :value="form.typeId">
                                <el-option label="通屏大图" :value="1"></el-option>
                                <el-option label="上图下字样式一" :value="2"></el-option>
                                <el-option label="上图下文样式二" :value="3"></el-option>
                                <el-option label="左字右图片" :value="4"></el-option>
                                <el-option label="上图下字样式三" :value="5"></el-option>
                                <el-option label="左图片右字" :value="6"></el-option>
                                <el-option label="标题及描述" :value="7"></el-option>
                                <el-option label="视频" :value="8"></el-option>
                                <el-option label="上图下字样式四" :value="9"></el-option>
                                <el-option label="数据看板" :value="10"></el-option>
                            </el-select>
						</el-form-item>
						<el-form-item label="标题" >
							<el-input v-model="form.title" style="width:30%"></el-input>
						</el-form-item>
						<el-form-item label="副标题" >
							<el-input v-model="form.subTitle" style="width:30%" rows="3"></el-input>
						</el-form-item>
                        
                        <el-form-item label="背景图">
							<el-upload drag  list-type="picture-card"  action="" multiple :limit="1" :on-success="getLogo" :file-list="logoList"
							 :on-remove="RemoveLogo" :on-exceed="handleLogo" :before-upload="beforePic" style="width:auto;float: left;">
								<i class="el-icon-picture-outline"></i>
								<br />
								<span class="uploadTip">将图片拖到此处，或点击上传</span>
							</el-upload>
							<input type="button" size="mini" class="bullet" style="display: inline-block;float: left;" @click.stop="dialogVisible = true"
							 value="素材库选择">
						</el-form-item>
                        <el-form-item label="其他图片">
							<el-upload drag  list-type="picture-card"  action="" multiple :on-success="getOther" :file-list="otherList"
							 :on-remove="RemoveOther" :on-exceed="handleOther" :before-upload="beforePicOth" style="width:auto;float: left;">
								<i class="el-icon-picture-outline"></i>
								<br />
								<span class="uploadTip">将图片拖到此处，或点击上传</span>
							</el-upload>
							<input type="button" size="mini" class="bullet" style="display: inline-block;float: left;" @click.stop="dialogVisible = true"
							 value="素材库选择">
						</el-form-item>
						<el-form-item label="专题内容" >
							<editor v-model="form.content" :isClear="isClear" @change="change" ></editor>
						</el-form-item>
                        <el-form-item>
							<input type="button" @click="onSubmit('form')" class="submit" value="提交">
						</el-form-item>
					</el-form>
				</el-card>
			</el-col>
		</el-row>
		<!-- 素材库选择 -->
		<el-dialog title="素材库选择" :visible.sync="dialogVisible" width="50%" :before-close="handleClose">
			<files @selectPic="selectPic"></files>
		</el-dialog>
		<!-- <el-dialog title="栏目选择" :visible.sync="dialogColumnVisible" width="50%" :before-close="handleClose">
			<span class="select">您已选择:{{form.column}}</span>
			<el-tree :data="data" show-checkbox node-key="id" :props="defaultProps" :default-checked-keys="selectCId" ref="tree"
			 @check="handleNodeClick">
			</el-tree>
		</el-dialog> -->
	</div>
</template>

<script>
	import Editor from '../../../components/tinymce.vue'
	import request from '../../../assets/js/request.js'
	import qs from 'qs'
	import files from '../../../components/picFile.vue'
	export default {
		components: {
			files,
			Editor,
		},
		data() {
			return {
				form: {
					id:'',
                    cid:'',
                    typeId:'',
                    title:'',
                    subTitle:'',
                    content:'',
                    bgImage:'',
                    othImage:'',
					// 栏目：
					column:[]
				},
				rules: {
                    type:[{
                        required:true,
                        massage:'请选择类型',
                        trigger:'blur'
                    }],
					title:[{
                        required:true,
                        massage:'请输入标题',
                        trigger:'blur'

                    }],
					cid: [{
						required: true,
						message: '请输入栏目',
						trigger: 'blur'
					}],
				},
                // 单选框
                Setypes: false,
				selectType: false,

				dialogVisible: false,
				// 背景图
				logoList: [],
				// 其他图片
				otherList:[],

				tableData: [],
				currentPage: 1,
				pageSize: 5,
				total: 0,
				loading: false,
				data: [],
				dialogColumnVisible: false,
				defaultProps: {
					children: 'childRpColum',
					label: 'columname'
				},
				loading: false,
				selectCId: [],
                editCheckId:'',

				isClear: false,

				iden:''

			}
		},
		created() {
			this.iden = this.$route.query.iden
			console.log(this.$route.query.rows)
			this.id = this.$route.query.id
			if (this.$route.query.iden == 'update') {
				this.form.id = this.$route.query.rows.id;
				this.form.cid = this.$route.query.rows.cid;
				this.form.typeId = this.$route.query.rows.typeId;
                this.form.title = this.$route.query.rows.title;
                this.form.subTitle = this.$route.query.rows.subTitle;
                this.form.content = this.$route.query.rows.content;
                this.form.bgImage = this.$route.query.rows.bgImage;
                this.form.othImage = this.$route.query.rows.othImage;
                this.logoList.push({url:this.settings.apiBaseImg+this.$route.query.rows.bgImage})
                var other = this.$route.query.rows.othImage.split(',')
                console.log(other.pop())
                console.log(other)
                for(var i = 0;i<other.length;i++){
                    this.otherList.push({url:this.settings.apiBaseImg+other[i]})
                }
				console.log(this.form.typeId)
			}else{
				this.form.cid = this.$route.query.rows
			}
		},
		methods: {

			//获取栏目
			getColumn() {
				this.dialogColumnVisible = true
				var obj = this;
				obj.$http({
					method: 'get',
					url: 'api/v1/column/list',
					params: {
						uid: localStorage.getItem('uid')
					},
				}).then((res) => {
					if (res.status == 200) {
						// this.data=res.data.data
						this.data = []
						res.data.data.forEach(item=>{
							if(item.modular=='8'){
								this.data.push(item)
							}
						})
						// this.data.push({
						// 	id:0,
						// 	columname:'首页'
						// })
					} else {
						obj.$message.error(res.data.msg)
					}
				})
			},
			//选择栏目
			handleNodeClick() {
				this.selectCId = this.$refs.tree.getCheckedKeys()
				var arr = []
				// this.form.cid = this.$refs.tree.getCurrentNode().id
				// console.log(this.$refs.tree.getCheckedNodes())
				for (var i = 0; i < this.$refs.tree.getCheckedNodes().length; i++) {
                    this.form.cid = this.$refs.tree.getCheckedNodes()[i].id
					arr.push(this.$refs.tree.getCheckedNodes()[i].columname)
				}
				this.form.column = arr.join(',')
			},
            
			//提价
			onSubmit(formName) {
				console.log(this.form.content)
				if (this.$route.query.iden == 'add') {
					this.$refs[formName].validate((valid) => {
						if (valid) {
							var obj = this;
							obj.$http({
								method: 'post',
								url: '/api/v1/special/add',
								data: {
                                    cid:this.form.cid,
                                    typeId:this.form.typeId,
									title:this.form.title,
									subTitle:this.form.subTitle,
									content:this.form.content,
									bgImage:this.form.bgImage,
								},
							}).then((res) => {
								if (res.data.status == 200) {
									this.$message.success('添加成功！');
									this.$router.push({
										path: '/home/special?id='+this.form.cid
									})
								} else {
									this.$message.error(res.data.message);
								}
							})
						} else {
							console.log('error submit!!');
							return false;
						}
					});

				} else {
					this.onUpdate()
				}
			},
			//上传图片之前调取接口
			beforePic(file, fileList) {
				this.loading = true
				let objUrl = file;
				let formData = new FormData();
				formData.append('file', objUrl);
				formData.append('uid', localStorage.getItem('uid'));
				var obj = this;
				obj.$http({
					method: 'post',
					url: '/api/v1/special/upload',
					data: formData,
				}).then((res) => {
					if (res.status == 200) {
						this.loading = false
                        console.log(res,'表单背景图')
						this.form.bgImage = res.data.data.images
						this.logoList=[]
						this.logoList.push({url:this.settings.apiBaseImg+res.data.data.imagesThumb})
					} else {
						obj.$message.error(res.data.message)
					}
				})
			},
			// 上传其他图片之前调用接口
			beforePicOth(file, fileList) {
				this.loading = true
				let objUrl = file;
				let formData = new FormData();
				formData.append('file', objUrl);
				formData.append('uid', localStorage.getItem('uid'));
				var obj = this;
				obj.$http({
					method: 'post',
					url: '/api/v1/special/upload',
					data: formData,
				}).then((res) => {
					if (res.status == 200) {
						this.loading = false
                        console.log(res,'其他图片')
						this.form.othImage += res.data.data.images+','
						this.otherList.push({url:this.settings.apiBaseImg+res.data.data.imagesThumb})
					} else {
						obj.$message.error(res.data.message)
					}
				})
			},
			//修改
			onUpdate() {
				console.log(this.form)
				var obj = this;
				obj.$http({
					method: 'post',
					url: '/api/v1/special/update',
					data: {
						id:this.form.id,
						cid:this.form.cid,
						title:this.form.title,
						typeId:this.form.typeId,
						subTitle:this.form.subTitle,
						content:this.form.content,
						bgImage:this.form.bgImage,
						othImage:this.form.othImage,
					},
				}).then((res) => {
					if (res.data.status == 200) {
						this.$message.success('修改成功！');
						this.$router.push({
							path: '/home/special?id='+this.form.cid
						})
					} else {
						this.$message.error(res.data.message);
					}
				})
			},
			//关闭弹窗
			handleClose(done) {
				done();
			},
			//上传图片成功
			getLogo(file, fileList) {
				this.form.bgImage = file.data.images
			},
			//删除图片
			RemoveLogo() {
				this.form.pic = ''
			},
			//图片限制
			handleLogo(files, fileList) {
				this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
			},

			// 上传其他图片成功
			getOther(file,fileList){
                console.log(fileList)
				this.otherList = fileList
			},
			// 删除图片
			RemoveOther(file,fileList){
                console.log(fileList)
				this.otherList = fileList
                this.form.othImage = ''
                for(var i = 0;i<this.otherList.length;i++){
                    this.form.othImage += this.otherList[i].url+','
                }
                console.log(this.otherList)
                console.log(this.form.othImage)
			},
			// 图片限制
			handleOther(){

			},
			//素材库选择图片
			selectPic(index, rows) {
				this.logoList=[]
				this.logoList.push({url:this.settings.apiBaseImg+ rows.path})
				this.form.pic = rows.path
				this.dialogVisible = false
			},
			// 富文本
			change(val) {
				console.log(val)
			},

		}
	}
</script>

<style scoped="scoped">
	.title {
		margin-bottom: 40px;
	}

	/deep/ .el-input__inner {
		height: 30px;
	}

	.picTip {

		height: 16px;
		font-size: 14px;
		font-family: PingFang SC;
		font-weight: 400;
		color: #000000;
		line-height: 24px;
		opacity: 0.5;
		margin-left: 10px;
	}

	.selectC {
		display: inline-block;

	}

	.selectC span {
		display: inline-block;
	}

	.selectC ul li {
		list-style: none;
		display: inline-block;
	}

	.select {
		font-size: 16px;
		font-weight: bold;
		display: block;
		margin-bottom: 20px;
	}
</style>



// WEBPACK FOOTER //
// src/views/system/special/specialAdd.vue